import { createSignal } from 'solid-js'
import { nextHistoryDepth } from './app-history-depth.js'

/*
    TENANT-0000. The mobile app's history depth as a signal, fed by the
    document's own history calls. Installed once, from main.jsx, in the app
    build only: the website has the browser's back button and needs none of
    this. The router navigates through `history.pushState`, so wrapping that
    one function sees every in-app navigation without the header having to be
    mounted on every route; `popstate` is the browser's own word for "went
    back"; `replaceState` is deliberately not counted (see nextHistoryDepth).
*/
const [
    historyDepth,
    setHistoryDepth,
] = createSignal(0)

export const appHistoryDepth = historyDepth

export const trackAppHistory = (view = globalThis) => {
    const {
        history,
    } = view
    const {
        pushState,
    } = history

    history.pushState = function pushStateCounted (...stateArguments) {
        const result = Reflect.apply(pushState, this, stateArguments)

        setHistoryDepth((depth) => nextHistoryDepth({
            change: 'push', depth,
        }))

        return result
    }

    view.addEventListener('popstate', () => {
        setHistoryDepth((depth) => nextHistoryDepth({
            change: 'pop', depth,
        }))
    })
}
